<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import LoadingMDL from '@/components/loading/LoadingMDL';

//ต้องมี check หน้า pre-test สับ route ถ้าไม่ได้ทำ
//ทำหน้าให้ dynamic ทุกวิชา

export default {
  name: 'Testing',
  components: {
    LoadingMDL,
  },
  data() {
    return {
      data: [],
      loading: true,
    };
  },

  mounted() {
    const contentId = this.$route.params.contentId;
    if (
      this.$store.state.v3.fetchBy == 'id' ||
      this.$store.state.v3.fetchBy == null
    ) {
      // by id
      console.log(contentId, 'forId');

      this.$store.dispatch('v3/fetchTemplateByContent', contentId);
    }
    if (this.$store.state.v3.fetchBy == 'code') {
      console.log(contentId, 'for code');

      this.$store.dispatch('v3/fetchTemplateByCode', contentId); // by codeItem
    }

    //this.$store.dispatch('v3/fetchCourseProgress', contentId);
  },
  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
    }),
  },
  watch: {
    getTemplatev3(data) {
      const codeTemplate = data.templates[0].codeTemplate.split('-');
      // console.log(data, 'form getTemplateV3');

      // renew data to store
      console.log('==================');
      console.log(data);
      this.$store.commit('v3/setTemplates', data);
      console.log('==================');

      if (data.type == 'menu') {
        // ถ้าเป็นหน้าเมนู เราจะทำการส่งข้อมูลที่ stake ไว้ไปยัง backend เพื่อทำการบันทึกหน้าที่เรียนไป
        console.log('this is menu page', this.$store.state.v3.completeContent);
      }

      if (codeTemplate.length > 1) {
        console.log('goto next', codeTemplate);
        this.$router.push(`/v4/${codeTemplate[0]}/${codeTemplate[1]}`);
      } else {
        this.$router.push('/');
      }
    },
  },
};
</script>
